import { SnapshotModel } from '..';
import { Collections } from '../../constants';
import { Product } from '../../enums';
import { mapAsync } from '../../helpers/array/async';
import { ColumnService } from '../../services/directory';
import { IntegrationSettings } from '../../types/integrationSettings';
import { wrapError, wrapSuccess } from '../../types/responses';
import { getErrorReporter } from '../../utils/errors';
import { safeGetModelArrayFromQuery } from '../getModel';
import { SerializedModel } from '../types';
import { OrganizationModel } from './organizationModel';

export type SerializedIntegrationSettingsModel = SerializedModel<
  typeof Collections.integrationSettings
>;

export class IntegrationSettingsModel extends SnapshotModel<
  IntegrationSettings,
  typeof Collections.integrationSettings
> {
  get type() {
    return Collections.integrationSettings;
  }

  public async getPublishers() {
    const [publishersError, publishers] = await mapAsync(
      Object.values(Product),
      async product => {
        const [queryError, queryResults] = await safeGetModelArrayFromQuery(
          OrganizationModel,
          this.ctx,
          this.ctx
            .organizationsRef()
            .where(`orderExport.${product}`, '==', this.ref)
        );

        if (queryError) {
          getErrorReporter().logAndCaptureError(
            ColumnService.INTEGRATIONS,
            queryError,
            'Failed to get publishers by product for integration settings',
            { integrationSettingsId: this.ref.id, product }
          );
          return wrapError(queryError);
        }

        const publishers = queryResults.map(publisher => ({
          publisher,
          product
        }));

        return wrapSuccess(publishers);
      }
    );

    if (publishersError) {
      getErrorReporter().logAndCaptureError(
        ColumnService.INTEGRATIONS,
        publishersError,
        'Failed to get publishers for integration settings',
        { integrationSettingsId: this.ref.id }
      );
      return wrapError(publishersError);
    }

    return wrapSuccess(
      publishers
        .flat()
        .sort((a, b) =>
          a.publisher.modelData.name.localeCompare(b.publisher.modelData.name)
        )
    );
  }
}
